import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSidenav } from '@angular/material/sidenav';
import { MatSort } from '@angular/material/sort';
import { Tables } from 'src/app/shared/entities/tables';
import { UserService } from 'src/app/admin/core/services/user.service';
import { DashboardComponent } from 'src/app/admin/core/components/dashboard/dashboard.component';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
@Component({
    selector: 'app-admin-home-page',
    templateUrl: './admin-home-page.component.html',
    styleUrls: ['./admin-home-page.component.css'],
})
export class AdminHomePageComponent implements OnInit {
    @Output() open: EventEmitter<number> = new EventEmitter();
    @Input() public tab: Tables = new Tables();
    //@Output() open = new EventEmitter<Tables>();
    @Input() public value: string;
    public activeIcon = false;
    displayedColumns: string[] = ['id', 'code', 'reference'];

    cards: any[] = [];

    name: any;
    pageIndex: number = 0;
    pageSize: number = 25;
    totalElements: number = 0;

    adminTab = {
        isMenuVisible: true,
        entite: 'dynamic_product',
        title: 'Produits',
        isTable: true,
        droitTitle: 'Produits',
        isDynamic: true,
    };

    constructor(
        public userService: UserService,
        private dash: DashboardComponent,
        private router: Router,
        private translate: TranslateService
    ) {}

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('sidenav') sidenav: MatSidenav;

    ngOnInit(): void {
        this.setName();
        // this.listenLanguageChange();

        setTimeout(() => {
            this.cards = [
                {
                    text: this.translate.instant('Admin.Tab.articles'),
                    toolTip: this.translate.instant('Admin.Tab.articles'),
                    droitTitle: this.translate.instant('Admin.Tab.articles'),
                    logo: '/assets/logo/arborescence.svg',
                    selected: true,
                    children: [],
                    entityName: 'dynamic_product',
                    isDynamic: true,
                    parentId: null,
                    filter: null,
                    listedechamps: null,
                    id: null,
                    filresappliques: null,
                    routerLink: '/admin/produits',
                },
                {
                    text: this.translate.instant('Admin.Tab.resources'),
                    toolTip: this.translate.instant('Admin.Tab.resources'),
                    droitTitle: this.translate.instant('Admin.Tab.resources'),
                    logo: '/assets/logo/arborescence.svg',
                    entityName: 'dynamic_ressource',
                    isDynamic: true,
                    selected: true,
                    filresappliques: null,
                    listedechamps: null,
                    routerLink: '/product/ressources',
                    children: [],
                },
                {
                    text: this.translate.instant('Admin.Tab.actualites'),
                    toolTip: this.translate.instant('Admin.Tab.actualites'),
                    droitTitle: this.translate.instant('Admin.Tab.actualites'),
                    logo: '/assets/logo/arborescence.svg',
                    selected: true,
                    children: [],
                    entityName: 'dynamic_news',
                    isDynamic: true,
                    filter: null,
                    listedechamps: null,
                    id: '',
                    filresappliques: null,
                    routerLink: '/admin/actualites',
                },
                {
                    text: this.translate.instant('Admin.Tab.personnesMorales'),
                    toolTip: this.translate.instant('Admin.Tab.personnesMorales'),
                    droitTitle: this.translate.instant('Admin.Tab.personnesMorales'),
                    logo: '/assets/logo/arborescence.svg',
                    selected: true,
                    children: [],
                    entityName: 'dynamic_legal_entity',
                    isDynamic: true,
                    filter: null,
                    listedechamps: null,
                    id: '',
                    filresappliques: null,
                    routerLink: '/admin/personnesMorales',
                },
                {
                    text: 'Import des trames',
                    toolTip: 'Import des trames',
                    droitTitle: 'Import des trames',
                    logo: '/assets/logo/arborescence.svg',
                    selected: true,
                    children: [],
                    entityName: null,
                    isDynamic: true,
                    filter: null,
                    listedechamps: null,
                    id: '',
                    filresappliques: null,
                    routerLink: null,
                    action: () => {
                        window.open(window.location.origin + '/import', '_blank');
                    },
                },
            ];

            if (this.userService.hasMenuAccess('Import des trames')) {
                let existingItem = this.cards.find((item) => item.text === 'Import des trames');
                if (!existingItem) {
                    this.cards.push({
                        text: 'Import des trames',
                        toolTip: 'Import des trames',
                        droitTitle: 'Import des trames',
                        logo: '/assets/logo/arborescence.svg',
                        selected: true,
                        children: [],
                        entityName: null,
                        isDynamic: false,
                        filter: null,
                        listedechamps: null,
                        id: '',
                        filresappliques: null,
                        routerLink: null,
                        action: () => {
                            window.open(window.location.origin + '/import', '_blank');
                        },
                    });
                }
            }

            if (this.userService.hasMenuAccess('Validation des trames')) {
                this.cards.push({
                    text: 'Validation des trames',
                    toolTip: 'Validation des trames',
                    droitTitle: 'Validation des trames',
                    logo: '/assets/logo/arborescence.svg',
                    selected: true,
                    children: [],
                    entityName: null,
                    isDynamic: false,
                    filter: null,
                    listedechamps: null,
                    id: '',
                    filresappliques: null,
                    routerLink: null,
                    action: () => {
                        window.open(window.location.origin + '/validation', '_blank');
                    },
                });
            }
        }, 2000);
    }

    setName() {
        let firstname =
            localStorage.getItem('name') !== undefined ? localStorage.getItem('name') : '';
        let surname =
            localStorage.getItem('surname') !== undefined ? localStorage.getItem('surname') : '';
        this.name = firstname + ' ' + surname;
    }

    openOnglet(menuItem: any) {
        if (menuItem.action) {
            menuItem.action();
        } else {
            if (!menuItem.entityName && menuItem.routerLink) {
                this.router.navigate([menuItem.routerLink]);
            } else {
                const tab = new Tables();
                tab.title = menuItem.text;
                tab.entite = menuItem.entityName;
                tab.droitTitle = menuItem.droitTitle;
                tab.id = menuItem.id;
                tab.isDynamic = menuItem.isDynamic;
                tab.typeName = menuItem.typeName;
                tab.filresappliques = menuItem.filresappliques;
                tab.listedechamps = menuItem.listedechamps;
                tab.isTable = true;
                tab.activeTable = 'actif';

                /*application d'un filtre ex : categorie de niveau 1 */
                tab.filter = menuItem.filter;
                tab.filresappliques = menuItem.filresappliques;
                this.dash.openOnglet(tab);
            }
        }
    }

    hasMenuAccess(ref: any): boolean {
        let hasaccess = false;
        if (this.userService.role?.backofficeRestrictions) {
            this.userService.role?.backofficeRestrictions?.menu.forEach((restriction: any) => {
                if (restriction?.text === ref && restriction?.selected) {
                    hasaccess = true;
                }
                if (restriction.children) {
                    restriction.children.forEach((child: any) => {
                        if (child?.text === ref && child?.selected) {
                            hasaccess = true;
                        }
                    });
                }
            });
        }
        return hasaccess;
    }

    listenLanguageChange() {
        setTimeout(() => {
            this.translate.stream('Admin.Tab.categories').subscribe((res: string) => {
                this.cards[0].text = res;
            });
            this.translate.stream('Admin.Tab.products').subscribe((res: string) => {
                this.cards[1].text = res;
            });
            this.translate.stream('Admin.Tab.articles').subscribe((res: string) => {
                this.cards[2].text = res;
            });
            this.translate.stream('Admin.Tab.userManagement').subscribe((res: string) => {
                this.cards[3].text = res;
            });
        }, 2000);
    }
}
